export const STORAGE_KEYS = {
  token: "TOKEN",
  credentials: "CREDENTIALS",
  rememberCredentials: "REMEMBER_CREDENTIALS",
  tempToken: "TEMP_TOKEN",
  fcmToken: "FCM_TOKEN",
  categoryType: "CATEGORY",
};
